/**
 * 日期工具函数 - 解决时区显示问题
 * 
 * 问题：new Date("2025-08-16") 会被解析为UTC时间，在本地时区显示时可能变成前一天
 * 解决：明确构造本地时间的Date对象，避免时区转换问题
 */

/**
 * 将日期字符串解析为本地时区的Date对象
 * @param dateString YYYY-MM-DD 格式的日期字符串
 * @returns 本地时区的Date对象
 */
export function parseLocalDate(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day); // 月份从0开始，所以减1
}

/**
 * 将日期字符串格式化为本地化显示
 * @param dateString YYYY-MM-DD 格式的日期字符串
 * @param locale 本地化设置，默认为中文
 * @param options Intl.DateTimeFormatOptions 格式化选项
 * @returns 格式化后的日期字符串
 */
export function formatLocalDate(
  dateString: string, 
  locale: string = 'zh-CN',
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'short'
  }
): string {
  const date = parseLocalDate(dateString);
  return date.toLocaleDateString(locale, options);
}

/**
 * 检查日期字符串是否为有效的YYYY-MM-DD格式
 * @param dateString 待检查的日期字符串
 * @returns 是否为有效格式
 */
export function isValidDateString(dateString: string): boolean {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) {
    return false;
  }
  
  const date = parseLocalDate(dateString);
  return !isNaN(date.getTime());
}